/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: f3eDTi4F2fC4
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonPage from "../../ButtonPage"; // plasmic-import: rG7NQ-o66beM/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicTopNav.module.css"; // plasmic-import: f3eDTi4F2fC4/css

createPlasmicElementProxy;

export const PlasmicTopNav__VariantProps = new Array("layoutType");

export const PlasmicTopNav__ArgProps = new Array(
  "pageButtons",
  "subdomainName"
);

const $$ = {};

function PlasmicTopNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          subdomainName: "subName"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layoutType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layoutType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"topnav"}
      data-plasmic-override={overrides.topnav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.topnav,
        {
          [sty.topnavlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"pageTitleSlot"}
        data-plasmic-override={overrides.pageTitleSlot}
        className={classNames(projectcss.all, sty.pageTitleSlot, {
          [sty.pageTitleSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.pageTitleSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__fgpwg
          )}
        >
          {"["}
        </div>
        <ButtonPage
          className={classNames("__wab_instance", sty.buttonPage__d0XAg)}
          content={"o21p"}
          onClick={async () => {
            const $steps = {};
            $steps["goToHttpsO21PCom"] = true
              ? (() => {
                  const actionArgs = { destination: "https://o21p.com/" };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      location.assign(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToHttpsO21PCom"] != null &&
              typeof $steps["goToHttpsO21PCom"] === "object" &&
              typeof $steps["goToHttpsO21PCom"].then === "function"
            ) {
              $steps["goToHttpsO21PCom"] = await $steps["goToHttpsO21PCom"];
            }
          }}
          textColor={"tertiary"}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__mFFsf
          )}
        >
          {"|"}
        </div>
        <ButtonPage
          className={classNames("__wab_instance", sty.buttonPage__o7Yi2)}
          content={"nexus"}
          onClick={async () => {
            const $steps = {};
            $steps["goToPartnerOverview"] = true
              ? (() => {
                  const actionArgs = { destination: `/` };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      location.assign(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToPartnerOverview"] != null &&
              typeof $steps["goToPartnerOverview"] === "object" &&
              typeof $steps["goToPartnerOverview"].then === "function"
            ) {
              $steps["goToPartnerOverview"] =
                await $steps["goToPartnerOverview"];
            }
          }}
          textColor={"tertiary"}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__h7EXq
          )}
        >
          {"]"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text___0Rlsu
          )}
        >
          {"o21p"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__x36MR
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.subdomainName;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "sub";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"topnavButtonsSlot"}
        data-plasmic-override={overrides.topnavButtonsSlot}
        className={classNames(projectcss.all, sty.topnavButtonsSlot, {
          [sty.topnavButtonsSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.topnavButtonsSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ysiAi
                )}
              >
                {"["}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage___8X6Fh)}
                content={"overview"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToPartnerOverview"] = true
                    ? (() => {
                        const actionArgs = { destination: `/` };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToPartnerOverview"] != null &&
                    typeof $steps["goToPartnerOverview"] === "object" &&
                    typeof $steps["goToPartnerOverview"].then === "function"
                  ) {
                    $steps["goToPartnerOverview"] =
                      await $steps["goToPartnerOverview"];
                  }
                }}
                textColor={"tertiary"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__gQrWb
                )}
              >
                {"|"}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage__xjZlR)}
                content={"support"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToPartnerOpenCall"] = true
                    ? (() => {
                        const actionArgs = {
                          destination: "https://o21p.com/support"
                        };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToPartnerOpenCall"] != null &&
                    typeof $steps["goToPartnerOpenCall"] === "object" &&
                    typeof $steps["goToPartnerOpenCall"].then === "function"
                  ) {
                    $steps["goToPartnerOpenCall"] =
                      await $steps["goToPartnerOpenCall"];
                  }
                }}
                textColor={"tertiary"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___350Jr
                )}
              >
                {"|"}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage__yawKu)}
                content={"sign up free"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToHttpsO21PComSignup"] = true
                    ? (() => {
                        const actionArgs = {
                          destination: "https://o21p.com/signup"
                        };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToHttpsO21PComSignup"] != null &&
                    typeof $steps["goToHttpsO21PComSignup"] === "object" &&
                    typeof $steps["goToHttpsO21PComSignup"].then === "function"
                  ) {
                    $steps["goToHttpsO21PComSignup"] =
                      await $steps["goToHttpsO21PComSignup"];
                  }
                }}
                textColor={"brand"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___95Ewy
                )}
              >
                {"]"}
              </div>
            </React.Fragment>
          ),

          value: args.pageButtons
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  topnav: ["topnav", "pageTitleSlot", "topnavButtonsSlot"],
  pageTitleSlot: ["pageTitleSlot"],
  topnavButtonsSlot: ["topnavButtonsSlot"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTopNav__ArgProps,
          internalVariantPropNames: PlasmicTopNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTopNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "topnav") {
    func.displayName = "PlasmicTopNav";
  } else {
    func.displayName = `PlasmicTopNav.${nodeName}`;
  }
  return func;
}

export const PlasmicTopNav = Object.assign(
  // Top-level PlasmicTopNav renders the root element
  makeNodeComponent("topnav"),
  {
    // Helper components rendering sub-elements
    pageTitleSlot: makeNodeComponent("pageTitleSlot"),
    topnavButtonsSlot: makeNodeComponent("topnavButtonsSlot"),
    // Metadata about props expected for PlasmicTopNav
    internalVariantProps: PlasmicTopNav__VariantProps,
    internalArgProps: PlasmicTopNav__ArgProps
  }
);

export default PlasmicTopNav;
/* prettier-ignore-end */
